import { Text as ChakraText, Circle, Flex, HStack, Link } from '@chakra-ui/react';

import React from 'react';
import { hexToRGBA } from '../utils/hexToRGBA';

export default function ParentLink(props) {
  const { navLink, navOpen,  application } = props;

  const brandColor = application.theme.colors.brand.primary;

  const parentLinkStyles = {
    alignItems: 'center',
    width: 'full',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#3a3a3a',
    paddingY: 3,
    paddingX: 4,
    _hover: {
      cursor: 'pointer',
      backgroundColor: hexToRGBA(brandColor, 0.1),
      color: '#3a3a3a',
      fontWeight: 600,
      textDecoration: 'none',
    },
  };
  

  return (
    <Flex as={Link} variant="unstyled" href={navLink.route} sx={parentLinkStyles}>
      <HStack spacing={2}>
            <Circle backgroundColor={hexToRGBA(brandColor, 0.1)} color="neutral.1500" size="32px">
                {navLink.icon}
            </Circle>

            {navOpen && <ChakraText>{navLink.name}</ChakraText>}
        </HStack>
    </Flex>
  ) 
}